// @flow

import Images from './images';
import Flags from './flags';
import Icons from './icons';

const Assets = {
    Images: Images,
    Flags: Flags,
    Icons: Icons
};

export default Assets;
